import { useEffect } from "react";

const INFIX = process.env.NODE_ENV === "production" ? "" : " – DEV ";

export default function useTitle(title: Nilable<string>) {
  useEffect(() => {
    if (title) {
      document.title = title + INFIX + (title.match(/Termitool\s*$/) ? "" : " – Termitool");
    }
  }, [title]);
}
